/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { Button, Menu, Dropdown } from 'antd'
// import moment from 'moment'
import { formatData } from '@integec/grid-tools'
class ExportComponents extends React.Component {
  constructor(props) {
    super(props)
    this.exportCSVData = this.exportCSVData.bind(this)
    this.exportData = this.exportData.bind(this)
    this.exportXLSData = this.exportXLSData.bind(this)
    this.menu = this.menu.bind(this)
    this.handleExport = this.handleExport.bind(this)
    this.getValue = this.getValue.bind(this)
  }

  exportData(blob, type, fileName) {
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob, { type })
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  getValue(header, value, rowData, filetype = 'csv') {
    // if (!value || (value + '').length <= 0) return ''
    let newValue = formatData({ header, value, rowData }) || ''
    // if (value === undefined || value == null || value === '') return ''
    // if (header.dataFormatter) return header.dataFormatter({ value })
    // if (header.type === 'date-time')
    //   return moment(value, header.dataFormat).format(header.displayFormat)
    if (!newValue && header.dataGetter)
      newValue = header.dataGetter({ rowData }) || ''

    // if csv then need to convert ,
    if (filetype === 'csv')
      return newValue.includes(',') ? newValue.replaceAll(',', '.') : newValue
    else return newValue
  }

  exportCSVData() {
    const { headers, data, getData, fileName } = this.props
    const actData = getData ? getData() : data
    let dataStr = ''
    headers.forEach(header => {
      dataStr = `${dataStr},${header.display}`
    })
    dataStr = `${dataStr.substring(1)}\n`
    actData.forEach(row => {
      let rowStr = ''
      headers.forEach(header => {
        if (header.ident === 'modifier' || header.ident === 'modifiedDate') {
          rowStr = `${rowStr},${
            header.ident === 'modifier'
              ? row.modificationInfo === undefined
                ? ''
                : row.modificationInfo.user
              : row.modificationInfo === undefined
              ? ''
              : row.modificationInfo.modDate
          }`
        } else {
          const value = `${
            row[header.ident] === undefined ? '' : row[header.ident]
          }`
          rowStr = `${rowStr},${this.getValue(header, value, row)}`
        }
      })
      rowStr = `${rowStr.substring(1)}\n`
      dataStr = `${dataStr}${rowStr}`
    })
    /* eslint-disable no-undef */
    const blob = new Blob([dataStr])
    /* eslint-disable no-undef */
    this.exportData(blob, 'text/csv', `${fileName}.csv`)
  }

  exportXLSData(filetype = 'xls') {
    const { headers, data, getData, fileName } = this.props
    const actData = getData ? getData() : data
    let dataStr =
      `<?xml version="1.0" encoding="UTF-8"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns:html="http://www.w3.org/TR/REC-html40">
<Worksheet ss:Name="` +
      fileName +
      `">
<Table>
<Column ss:Index="1" ss:AutoFitWidth="0" ss:Width="110"/>
<Row>`

    headers.forEach(header => {
      dataStr = `${dataStr}
<Cell><Data ss:Type="String">${header.display}</Data></Cell>`
    })
    dataStr = `${dataStr}</Row>`

    actData.forEach(row => {
      let rowStr = `<Row>`
      headers.forEach(header => {
        if (header.ident === 'modifier' || header.ident === 'modifiedDate') {
          rowStr = `${rowStr}
          <Cell><Data ss:Type="${
            header.type === 'num' ? 'Number' : 'String'
          }">${
            header.ident === 'modifier'
              ? row.modificationInfo === undefined
                ? ''
                : row.modificationInfo.user
              : row.modificationInfo === undefined
              ? ''
              : row.modificationInfo.modDate
          }</Data></Cell>`
        } else {
          const nv = this.getValue(header, row[header.ident], row, filetype)

          rowStr = `${rowStr}
<Cell><Data ss:Type="${
            row[header.ident] === undefined || isNaN(nv)
              ? 'String'
              : header.type === 'num'
              ? 'Number'
              : 'String'
          }">${
            nv === undefined ? '' : header.type === 'num' ? nv : nv
          }</Data></Cell>`
        }
      })
      rowStr = `${rowStr}
</Row>`
      dataStr = `${dataStr}${rowStr}`
    })
    dataStr = `${dataStr}
</Table>
</Worksheet>
</Workbook>`
    const blob = new Blob([dataStr])
    this.exportData(blob, 'text/xls', `${fileName}.xls`)
  }

  handleExport(e) {
    if (e.key === 'csv') this.exportCSVData('csv')
    else if (e.key === 'xls') this.exportXLSData('xls')
  }

  menu() {
    return (
      <Menu onClick={this.handleExport}>
        <Menu.Item key="csv">CSV</Menu.Item>
        <Menu.Item key="xls">XLS</Menu.Item>
      </Menu>
    )
  }

  render() {
    return (
      // <Button style={btnStyle} onClick={exportCSVData} icon="export">
      //   Export
      // </Button>
      <Dropdown overlay={this.menu} disabled={this.props.disabled || false}>
        <Button style={this.props.btnStyle} icon="export">
          {this.props.title ? this.props.title : 'Export'}
        </Button>
      </Dropdown>
    )
  }
}
export default ExportComponents
